/**
 * Central brand asset constants — single import for the official AllSale™
 * mark. `GET /api/classifieds/site-settings → settings.logo_url` is the
 * source of truth (founder can swap the URL from Admin at any time). We
 * fall back to the current Cloudinary URL when settings is unreachable so
 * the site never renders un-branded.
 *
 * If the founder ever changes the official mark, update `OFFICIAL_LOGO_URL`
 * here to keep the fallback in sync — but the admin URL takes precedence
 * so this bake-in is only ever visible during a site-settings outage.
 */
export const OFFICIAL_LOGO_URL =
  // Iter 743 — media host moved to Bunny.net (Cloudinary gets cancelled).
  "https://allsale.b-cdn.net/branding/allsale-logo-master.png";

/**
 * Resolves the best-available logo URL. Consumers should prefer this
 * helper over reading `settings.logo_url` directly so the fallback stays
 * consistent everywhere.
 */
export function resolveLogoUrl(settings) {
  return settings?.logo_url || OFFICIAL_LOGO_URL;
}
